var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBackword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65158 5.67589L7.00293 10.0272L5.67861 11.3516L0.00292969 5.67589L5.67861 0.000211716L7.00293 1.32454L2.65158 5.67589Z",
    fill: "#176939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBackword);
export default __webpack_public_path__ + "static/media/chevron_backword.9242b3b11e8533e7f921a95500f0f11a.svg";
export { ForwardRef as ReactComponent };